// 🚀 ACCTOO MULTI-COMPANY PLATFORM - ENTRY POINT
// This is the main entry point for the ACCTOO React application

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 🎯 Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// 🚀 Render ACCTOO Application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 📊 Performance monitoring
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
